import React from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';

const PMKisanYearlyChart = ({ data, selectedYear, isHindi, darkMode }) => {
  // Get the trend line data (from toggleOptions[0])
  const trendLineData = data['chart-data'] || [];

  // Dark mode theme configuration
  const chartTheme = darkMode
    ? {
        backgroundColor: '#234046',
        textColor: '#FFFFFF',
        gridLineColor: '#3B3B3B',
        lineColor: '#575757',
      }
    : {
        backgroundColor: '#FFFFFF',
        textColor: '#2b2b2b',
        gridLineColor: '#E6E6E6',
        lineColor: '#CCCCCC',
      };

  if (!selectedYear) {
    return (
      <div
        style={{
          height: '420px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: darkMode ? '#BCBCBC' : '#999',
          fontSize: '16px',
          backgroundColor: chartTheme.backgroundColor,
        }}
      >
        {isHindi
          ? 'जानकारी देखने हेतु एक वित्तीय वर्ष का चयन करें'
          : 'Please select a financial year to view data'}
      </div>
    );
  }

  // Filter data for selected year
  const yearData = trendLineData.filter((item) => {
    // Extract year from "DEC–MAR 2019-20" -> "2019-20"
    const itemYear = item.period.split(' ')[1];
    return itemYear === selectedYear;
  });

  if (yearData.length === 0) {
    return (
      <div
        style={{
          height: '420px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: darkMode ? '#BCBCBC' : '#999',
          fontSize: '16px',
          backgroundColor: chartTheme.backgroundColor,
        }}
      >
        {isHindi
          ? `${selectedYear} के लिए कोई जानकारी उपलब्ध नहीं है`
          : `No data available for ${selectedYear}`}
      </div>
    );
  }

  // Create full labels with installment number and period
  const categories = yearData.map((item) => {
    const monthRange = item.period.split(' ')[0]; // "DEC–MAR" or "APR–JUL"
    return `${item.installment} ${isHindi ? 'किस्त' : 'Installment'} (${monthRange})`;
  });

  const beneficiariesData = yearData.map((item) => item.beneficiaries);

  const options = {
    chart: {
      type: 'column',
      height: 420,
      backgroundColor: chartTheme.backgroundColor,
    },
    title: {
      text: isHindi
        ? `पीएम-किसान करोड़ - वित्त वर्ष ${selectedYear}`
        : `PM-KISAN Beneficiaries - FY ${selectedYear}`,
      style: {
        fontSize: '16px',
        fontWeight: '600',
        color: chartTheme.textColor,
      },
    },
    xAxis: {
      categories,
      title: {
        text: isHindi ? 'किस्त' : 'Installment',
        style: {
          color: chartTheme.textColor,
        },
      },
      labels: {
        style: {
          color: chartTheme.textColor,
        },
      },
      lineColor: chartTheme.lineColor,
      tickColor: chartTheme.lineColor,
    },
    yAxis: {
      min: 0,
      title: {
        text: isHindi ? 'लाभार्थी (करोड़ में)' : 'Beneficiaries (in crore)',
        style: {
          color: chartTheme.textColor,
        },
      },
      labels: {
        style: {
          color: chartTheme.textColor,
        },
      },
      gridLineColor: chartTheme.gridLineColor,
    },
    tooltip: {
      valueSuffix: isHindi ? 'करोड़' : ' Cr',
      pointFormat: isHindi ? '<b>{point.y}</b> लाभार्थी' : '<b>{point.y}</b> beneficiaries',
      backgroundColor: darkMode ? '#3B3B3B' : '#FFFFFF',
      borderColor: darkMode ? '#575757' : '#CCCCCC',
      style: {
        color: chartTheme.textColor,
      },
    },
    legend: {
      enabled: false,
    },
    plotOptions: {
      column: {
        borderRadius: 3,
        color: '#544FC5',
        dataLabels: {
          enabled: false,
        },
      },
    },
    series: [
      {
        name: isHindi ? 'लाभार्थी' : 'Beneficiaries',
        data: beneficiariesData,
      },
    ],
    credits: {
      enabled: false,
    },
  };

  return <HighchartsReact highcharts={Highcharts} options={options} />;
};

export default PMKisanYearlyChart;
